module.exports = __webpack_public_path__ + "img/23.b0b05d0f.png";